import { MyleHelper } from "@/Common/Helpers/MyleHelper";
import { IDocumentsTabModel } from "../UI/IDocumentsTabModel";

class DocumentSearchSettings {
    public IsAllSitesChecked: boolean;
    public IsAllCliniciansChecked: boolean;
    public IsAllStatusChecked: boolean;
    public IsAllUrgencyChecked: boolean;
    public IsAllSentByChecked: boolean;
    public IsAllPortalChecked: boolean;
    public SelectAllClassesChecked: boolean;
    public SiteIds: string[];
    public ShowOnlySelectedSite: boolean;
    public ClinicianIds: string[];
    public ClassIds: string[];
    public SentByIds: string[];
    public Status: string[];
    public PortalStatus: string[];
    public Urgency: string[];
    public PageSize: number;

    constructor(fields?: Partial<DocumentSearchSettings>) {
        (Object as any).assign(this, fields);
    }

    public static FromDocTabModel(model: IDocumentsTabModel): DocumentSearchSettings {
        let helper = new MyleHelper();

        let display: DocumentSearchSettings = new DocumentSearchSettings();
        display.IsAllSitesChecked = model.get("SelectAllSitesChecked") || false;
        display.IsAllCliniciansChecked = model.get("SelectAllCliniciansChecked") || false;
        display.IsAllStatusChecked = model.get("SelectAllStatusChecked") || false;
        display.IsAllUrgencyChecked = model.get("SelectAllUrgencyChecked") || false;
        display.IsAllSentByChecked = model.get("SelectAllSentByChecked") || false;
        display.IsAllPortalChecked = model.get("SelectAllPortalStatus") || false;
        display.SelectAllClassesChecked = model.get("SelectAllClassesChecked") || false;
        display.SiteIds = helper.GetCheckedItemsFromICheckableList(model.get("Sites")).map(x => x.Id).toArray();
        display.ShowOnlySelectedSite = model.get("ShowOnlySelectedSites") || false;
        display.ClinicianIds = helper.GetCheckedItemsFromICheckableList(model.get("CliniciansGlobalCache")).map(x => x.Id).toArray();
        display.SentByIds = helper.GetCheckedItemsFromICheckableList(model.get("SentByGlobalCache")).map(x => x.Id).toArray();
        display.Status = helper.GetCheckedItemsFromICheckableList(model.get("Status")).map(x => x.Id).toArray();
        display.PortalStatus = helper.GetCheckedItemsFromICheckableList(model.get("PortalStatuses")).map(x => x.Id).toArray();
        display.Urgency = helper.GetCheckedItemsFromICheckableList(model.get("Urgency")).map(x => x.Id).toArray();
        display.PageSize = model.get("SelectedPageSizeOption");
        display.ClassIds = helper.GetCheckedItemsFromICheckableList(model.get("Classes")).map(x => x.Id).toArray();

        return display;
    }
}

export { DocumentSearchSettings };
